import { render } from "./StrykerCommandAdmin.vue?vue&type=template&id=27905066&scoped=true"
import script from "./StrykerCommandAdmin.vue?vue&type=script&lang=js"
export * from "./StrykerCommandAdmin.vue?vue&type=script&lang=js"

import "./StrykerCommandAdmin.vue?vue&type=style&index=0&id=27905066&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27905066"]])

export default __exports__